export default {
    getRoleName (roleId) {
        let availableRoles = {
            0 : 'Administrador',
            1 : 'Gestor',
            2 : 'Garçom'
        }
        return availableRoles[roleId]
    }
}